import { IAlarmsFlexidas } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';
import { TEmptyObject } from '@interfaces/common/common';

import { EVendorsValues } from '@enums/common';

import { useQueryActiveAlarms } from '../useQueryActiveAlarms';
import { useQueryActiveAlarmsFlexidas } from '../useQueryActiveAlarmsFlexidas';

import { useQueryActiveAlarmsListOran } from './useQueryActiveAlarmsListOran';

interface IUseQueryAlarmsReturn {
	isLoadingTable: boolean;
	activeAlarmList: IAlarmsFlexidas[];
	countOfRecords: number;
	invalidateQuery: () => void;
}

interface AlarmData<T = any> {
	isLoading: boolean;
	data: T[];
	countOfRecords: number;
	invalidateQuery: () => void;
}

const getAlarmsList = ({
	flexidas,
	limenet,
	oran,
	benetel,
	vendor,
}: {
	flexidas: AlarmData;
	limenet: AlarmData;
	oran: AlarmData;
	benetel: AlarmData;
	vendor?: string;
}): TEmptyObject | AlarmData => {
	switch (vendor) {
		case EVendorsValues.flexidas:
			return flexidas;
		case EVendorsValues.limenet:
			return limenet;
		case EVendorsValues.oran:
			return oran;
		case EVendorsValues.benetel:
			return benetel;
		default:
			return {};
	}
};

export const useQueryActiveAlarmsList = (params: IAlarmByVendor): IUseQueryAlarmsReturn => {
	const flexidas = useQueryActiveAlarmsFlexidas(params);
	const limenet = useQueryActiveAlarms(params);
	const oran = useQueryActiveAlarmsListOran(params);

	const {
		data = [],
		isLoading = false,
		countOfRecords = 0,
		invalidateQuery,
	} = getAlarmsList({
		flexidas,
		limenet,
		oran,
		benetel: oran,
		vendor: params.vendor,
	}) || {};

	return {
		isLoadingTable: isLoading,
		activeAlarmList: data,
		countOfRecords: countOfRecords,
		invalidateQuery,
	};
};
